module.exports = __webpack_public_path__ + "img/joutu.4657fad0.gif";